// extracted by mini-css-extract-plugin
module.exports = {"container":"_93444fe79c--container--NynHE","warning":"_93444fe79c--warning--hBXme"};